import { createContext, useContext } from "react";

export type SidebarLayoutContextValue = {
    isSidebarCollapsed: boolean;
};

const defaultValue: SidebarLayoutContextValue = {
    isSidebarCollapsed: false,
};

export const SidebarLayoutContext = createContext<SidebarLayoutContextValue>(defaultValue);

export const SidebarLayoutProvider = SidebarLayoutContext.Provider;

export function useSidebarLayout(): SidebarLayoutContextValue {
    return useContext(SidebarLayoutContext);
}

/** Expanded sidebar: inline deleted/disabled audit when viewport width is below 1321px. */
export const RECORD_AUDIT_INLINE_EXPANDED_MAX_WIDTH = 1320;

/** Collapsed sidebar: inline deleted/disabled audit when viewport width is below 1109px. */
export const RECORD_AUDIT_INLINE_COLLAPSED_MAX_WIDTH = 1108;

export function shouldInlineSecondaryRecordAudit(
    viewportWidth: number,
    isSidebarCollapsed: boolean
): boolean {
    const maxWidth = isSidebarCollapsed
        ? RECORD_AUDIT_INLINE_COLLAPSED_MAX_WIDTH
        : RECORD_AUDIT_INLINE_EXPANDED_MAX_WIDTH;
    return viewportWidth <= maxWidth;
}
